import getAssociationKeysReduxUtil from 'modules/redux/utils/get-associations-keys'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import isNewReduxUtil from 'modules/redux/utils/is-new'
import createSingleAssociationCreateReduxUtil from 'modules/redux/actions/create/create-single-association'
import createAssociationListCreateReduxUtil from 'modules/redux/actions/create/create-association-list'
import { isEmptyUtil } from 'packages/src'

export default function createAssociationsCreateReduxUtil (stateWrapper, payload) {
  let {
    instance,
    existingInstance
  } = payload
  const associationKeys = getAssociationKeysReduxUtil(instance)
  const isLocal = isNewReduxUtil(instance)
  if (associationKeys.length) {
    associationKeys.forEach(associationKey => {
      const association = getValueReduxUtil(instance, associationKey)
      if (isEmptyUtil(association)) {
        return
      }
      const dataKey = isLocal ? 'changed' : 'data'
      const dataPath = `${dataKey}.${associationKey}`
      const properties = {
        status: instance.status
      }
      const associationParams = {
        stateWrapper,
        association,
        existingInstance,
        isLocal,
        instance,
        dataPath,
        properties,
        associationKey
      }
      instance = Array.isArray(association)
        ? createAssociationListCreateReduxUtil(associationParams)
        : createSingleAssociationCreateReduxUtil(associationParams)
    })
  }
  return instance
}
